/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_haiku_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does a haiku have to be exactly 5-7-5?`)
};

const es_syl_haiku_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Un haiku tiene que ser exactamente 5-7-5?`)
};

const de_syl_haiku_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muss ein Haiku exakt 5-7-5 sein?`)
};

const nl_syl_haiku_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moet een haiku precies 5-7-5 zijn?`)
};

const fr_syl_haiku_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un haïku doit-il être exactement en 5-7-5 ?`)
};

const it_syl_haiku_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un haiku deve essere esattamente 5-7-5?`)
};

const pt_br2_syl_haiku_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um haiku precisa ser exatamente 5-7-5?`)
};

const pt_syl_haiku_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um haiku tem de ser exatamente 5-7-5?`)
};

const ja_syl_haiku_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`俳句は必ず5-7-5でなければいけませんか？`)
};

const zh_syl_haiku_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`俳句一定要严格遵循5-7-5格式吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_haiku_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_haiku_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_haiku_faq2_q", locale)
	if (locale === "en") return en_syl_haiku_faq2_q(inputs)
	if (locale === "es") return es_syl_haiku_faq2_q(inputs)
	if (locale === "de") return de_syl_haiku_faq2_q(inputs)
	if (locale === "nl") return nl_syl_haiku_faq2_q(inputs)
	if (locale === "fr") return fr_syl_haiku_faq2_q(inputs)
	if (locale === "it") return it_syl_haiku_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_syl_haiku_faq2_q(inputs)
	if (locale === "pt") return pt_syl_haiku_faq2_q(inputs)
	if (locale === "ja") return ja_syl_haiku_faq2_q(inputs)
	return zh_syl_haiku_faq2_q(inputs)
};